export default {
    apiKey: "AIzaSyABkwj9dhGsS8Hcd4NTG8jkL97Sh1OR-fw",
    authDomain: "kash-party.firebaseapp.com",
    databaseURL: "https://kash-party.firebaseio.com",
    projectId: "kash-party",
    storageBucket: "kash-party.appspot.com",
    messagingSenderId: "97989002836",
    appId: "1:97989002836:web:d6a86ee0bb51e07a254fc1"
}